import React, { Component, useContext } from "react";
import { useHistory, Link, NavLink } from "react-router-dom";

import LogsList from "../../../Components/Admin/Logs/LogsList";

function UserLogsIndex(props) {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="container-fluid">
        <h2>Logs</h2>
        <hr />
        <div className="row">
          <LogsList />
        </div>
      </div>
    </React.Fragment>
  );
}

export default UserLogsIndex;
